import { staticText } from '../../utils/translations/staticText';

const baseTranslations = staticText({
  ends: {
    _: 'Ends {date}',
    zh: '截止 {date}',
  },
  // `zh` is Simplified and serves zh-tw; Hong Kong needs Traditional.
  flash_deal_default_label: {
    _: 'Flash Deal! Limited slots only ⚡',
    zh: '限时闪购！名额有限 ⚡',
    'zh-hk': '快閃優惠！名額有限 ⚡',
  },
  offer_ended: {
    _: 'Offer ended',
    zh: '优惠已结束',
    'zh-hk': '優惠已結束',
  },
  offer_ends: {
    _: 'Offer ends {date}',
    zh: '优惠将于 {date} 结束',
    'zh-hk': '優惠將於 {date} 結束',
  },
});

export const TRANSLATIONS = staticText(baseTranslations);

export type UrgencyBarTranslationKey = keyof typeof baseTranslations;
